import { styled } from "@mui/material/styles";

export const InfoToolTipCardHeader = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "var(--space-sm)",
  marginBottom: "var(--space-sm)",
});

export const IntoToolTipCardTitle = styled("span")({
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  gap: "var(--space-xxs)",
});

export const CardTitleText = styled("span")({
  fontSize: "var(--font-size-base)",
  fontWeight: "var(--font-weight-bold)",
});

export const CardSubTitleText = styled("span")({
  fontSize: "var(--font-size-md)",
  fontWeight: "var(--font-weight-bold)",
  color: "var(--color-text-primary)",
});

export const InfoToolTipCardBody = styled("div")({
  borderRadius: "var(--radius-md)",
});

export const InfoToolTipCardBodyListItem = styled("div")({
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "flex-start",
  gap: "var(--space-xxs)",
  "&:not(:last-child)": {
    marginBottom: "var(--space-xs)",
  },
});

export const InfoToolTipCardBodyListItemText = styled("p")({
  color: "var(--color-text-primary)",
  wordBreak: "break-word",
  whiteSpace: "normal",
  textAlign: "justify",
  fontSize: "var(--font-size-xs)",
  fontWeight: "var(--font-weight-medium)",
});
